module.exports = __webpack_public_path__ + "static/media/2017_conf_Successful_Products_by_Prioritizing_Team_Happiness.0a7714e7.png";